import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const PC = {
  STARTER: 'bg-zinc-100 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-300',
  PRO: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
  PREMIUM: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
};

function ShopItem({ shop }) {
  return (
    <div className="p-3 rounded-lg border bg-muted/50 mb-2">
      <p className="font-medium text-sm">{shop.name}</p>
      <p className="text-xs text-muted-foreground mt-1">
        {shop.categoryCount || 0} cat. / {shop.productCount || 0} prod.
      </p>
    </div>
  );
}

function UserInfo({ user }) {
  var shops = user.shops || [];
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div><p className="text-xs text-muted-foreground">Nom</p><p className="font-medium">{user.name}</p></div>
        <div><p className="text-xs text-muted-foreground">Email</p><p className="font-medium">{user.email}</p></div>
        <div><p className="text-xs text-muted-foreground">Plan</p><Badge className={PC[user.plan]}>{user.plan}</Badge></div>
        <div>
          <p className="text-xs text-muted-foreground">Statut</p>
          <Badge className={user.isActive !== false ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700'}>
            {user.isActive !== false ? 'Actif' : 'Inactif'}
          </Badge>
        </div>
        <div className="col-span-2">
          <p className="text-xs text-muted-foreground">Inscription</p>
          <p className="font-medium">{new Date(user.createdAt).toLocaleDateString('fr-FR')}</p>
        </div>
      </div>
      {shops.length > 0 && (
        <div>
          <h4 className="font-semibold text-sm mb-2">Boutiques ({shops.length})</h4>
          {shops.map(function(s) { return <ShopItem key={s.id} shop={s} />; })}
        </div>
      )}
    </div>
  );
}

export function DetailUserDialog({ user, onClose }) {
  if (!user) return null;
  return (
    <Dialog open={true} onOpenChange={function(v) { if (!v) onClose(); }}>
      <DialogContent className="max-w-lg" data-testid="user-detail-dialog">
        <DialogHeader><DialogTitle>{"D\u00e9tails"}</DialogTitle></DialogHeader>
        <UserInfo user={user} />
      </DialogContent>
    </Dialog>
  );
}
